import ax from 'axios'
import { merge } from 'lodash'
import config from '@/config'
import store from '../state/store'
let instance
let axios

class GeocodeBaseApi {
  constructor() {
    if (!instance) {
      instance = this
    }
    const axiosConfig = {
      baseURL: config.auth_url + "/api/services/geocode",
      timeout: 60000
    }
    axios = ax.create(axiosConfig)
    // console.log('BaseApi NEW')
    return instance
  }

  setAuthToken(token) {
    if (axios) {
      axios.defaults.headers.common.Authorization = 'Bearer ' + token
    }
  }

  async submit(method, url, data, config = {}) {
    return this._submit(method, url, data, config)
      .then(val => {
        return val
      })
      .catch(error => {
        throw this._handleError(error)
      })
  }

  _submit(method, url, data, configRequest = {}) {
    method = method.toLowerCase();
    // transformRequest for get method
    if (method === 'get') {
      data = this._transformGetData(configRequest, data)
    }
    let params
    if (method === 'get') {
      params = data
    }
    configRequest = merge(
      {
        method: method,
        url: url,
        params: params,
        data: method !== 'get' ? data : {},
        headers: {
          Accept: 'application/json',
          'Content-Type':
            data instanceof window.FormData
              ? 'multipart/form-data'
              : 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      },
      configRequest
    )
    return axios(configRequest)
  }

  _handleError(error) {
    let formatError = {}
    if (!error.response) {
      formatError = {
        message: error.message,
        status_code:
          error.constructor.name === 'Cancel' || error.constructor.name === 'r'
            ? 499
            : 404,
        data: error
      }
      return formatError
    }
    switch (error.response.status) {
      case 422:
        let messageErrors = []
        for (const property in error.response.data.errors) {
          messageErrors.push(
            `${error.response.data.errors[property][0].replace('.', ',')}`
          )
        }
        error.response.data.message = messageErrors.join(' ')
        break
    }
    switch (error.response.status) {
      default:
        formatError = error.response.data
    }

    return formatError
  }

  _transformGetData(config, data) {
    if (this._needToTransform(config, data)) {
      data = JSON.parse(config.transformRequest[0](data))
      config.transformRequest = [] // Must call after call transformRequest
      return data
    } else {
      return data
    }
  }

  _needToTransform(config) {
    return (
      config.transformRequest &&
      config.transformRequest.length > 0 &&
      typeof config.transformRequest[0] === 'function'
    )
  }
}

export default GeocodeBaseApi



// WEBPACK FOOTER //
// ./src/api/GeocodeBaseApi.js